export const bookingOptions = [
  //   {
  //     value: '',
  //     label: '-'
  //   },
  {
    value: 30,
    label: 'Every 30 minutes'
  },
  {
    value: 60,
    label: 'Every 1 hour'
  },
  {
    value: 120,
    label: 'Every 2 hours'
  }
]
